import { withStyles } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";

const styles = (theme: Theme) => createStyles({});

interface IProps {
  url?: string;
}

const Ad: React.SFC<IProps> = (props: IProps) => {
  if (!props.url) {
    return <div>Awaiting transaction...</div>;
  }

  return <iframe height="5000" name="ad" src={props.url} width="100%" />;
};

export default withStyles(styles)(Ad);



// WEBPACK FOOTER //
// ./src/components/Ad.tsx